import { escapeAttribute, escapeHtml } from "./dom";
export function input(label, name, value = "", type = "text") {
    return `
    <label>
      <span>${escapeHtml(label)}</span>
      <input type="${escapeHtml(type)}" name="${escapeHtml(name)}" value="${escapeAttribute(value)}" />
    </label>
  `;
}
